.flavorCard {
  background-color: var(--colors-grays-ultralight);
  border-radius: 24px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  flex: 1;
  height: 72px;
}
